export const messages = {
  en: {
    advertManage: {
      search: {
        title: 'Search Conditions',
        hide: 'Hide',
        more: 'More',
        adNamePlaceholder: 'Please enter the advertisement name',
        classifyPlaceholder: 'Please select the advertisement category',
        locationPlaceholder: 'Please select the placement location'
      },
      list: {
        title: 'Advertisement Information',
        publish: 'Publish',
        viewAdvert: 'View Advertisement'
      },
      table: {
        advertId: 'Advertisement ID',
        adName: 'Advertisement Name',
        classify: 'Advertisement Category',
        location: 'Placement Location',
        advertType: 'Publish Type',
        startTime: 'Start Time',
        endTime: 'End Time',
        createTime: 'Creation Time'
      },
      advertType: {
        site: 'Site',
        outside: 'Outside',
        noJump: 'No Jump'
      },
      classify: {
        logistics: 'Logistics',
        catering: 'Catering',
        travel: 'Travel',
        hotel: 'Hotel',
        education: 'Education',
        internet: 'Internet'
      },
      add: {
        title: 'Publish Advertisement',
        adName: 'Advertisement Name',
        adNamePlaceholder: 'Required, please enter the advertisement name',
        classify: 'Advertisement Category',
        classifyPlaceholder: 'Required, please select the advertisement category',
        locationTypeCd: 'Placement Location',
        locationPlaceholder: 'Required, please select the placement location',
        advertType: 'Publish Type',
        advertTypePlaceholder: 'Required, please select the publish type',
        pageUrl: 'Jump Path',
        pageUrlPlaceholder: 'Please enter the jump path',
        seq: 'Play Order',
        seqPlaceholder: 'Required, please enter the play order',
        startTime: 'Start Time',
        startTimePlaceholder: 'Required, please select the start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Required, please select the end time',
        viewType: 'Play Method',
        viewTypePlaceholder: 'Required, please select the play method',
        image: 'Image (800 * 373)',
        success: 'Advertisement published successfully'
      },
      edit: {
        title: 'Edit Advertisement',
        adName: 'Advertisement Name',
        adNamePlaceholder: 'Required, please enter the advertisement name',
        classify: 'Advertisement Category',
        classifyPlaceholder: 'Required, please select the advertisement category',
        locationTypeCd: 'Placement Location',
        locationPlaceholder: 'Required, please select the placement location',
        advertType: 'Publish Type',
        advertTypePlaceholder: 'Required, please select the publish type',
        pageUrl: 'Jump Path',
        pageUrlPlaceholder: 'Please enter the jump path',
        seq: 'Play Order',
        seqPlaceholder: 'Required, please enter the play order',
        startTime: 'Start Time',
        startTimePlaceholder: 'Required, please select the start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Required, please select the end time',
        viewType: 'Play Method',
        viewTypePlaceholder: 'Required, please select the play method',
        image: 'Image (800 * 373)',
        success: 'Advertisement updated successfully'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this advertisement?',
        success: 'Advertisement deleted successfully'
      },
      machine: {
        title: 'Advertisement Device Code',
        machineCode: 'Device Code',
        machineCodePlaceholder: 'Required, please enter the device code',
        view: 'View Advertisement'
      },
      validate: {
        adNameRequired: 'Advertisement name is required',
        classifyRequired: 'Advertisement category is required',
        locationRequired: 'Placement location is required',
        advertTypeRequired: 'Publish type is required',
        seqRequired: 'Play order is required',
        seqNumber: 'Play order must be a number',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        viewTypeRequired: 'Play method is required',
        imageRequired: 'Please upload image',
        machineCodeRequired: 'Device code is required'
      },
      fetchError: 'Failed to get advertisement list',
      fetchLocationError: 'Failed to get location types'
    }
  },
  zh: {
    advertManage: {
      search: {
        title: '查询条件',
        hide: '隐藏',
        more: '更多',
        adNamePlaceholder: '请输入广告名称',
        classifyPlaceholder: '请选择广告分类',
        locationPlaceholder: '请选择投放位置'
      },
      list: {
        title: '广告信息',
        publish: '发布',
        viewAdvert: '查看广告'
      },
      table: {
        advertId: '广告ID',
        adName: '广告名称',
        classify: '广告分类',
        location: '投放位置',
        advertType: '发布类型',
        startTime: '投放时间',
        endTime: '结束时间',
        createTime: '创建时间'
      },
      advertType: {
        site: '站内',
        outside: '站外',
        noJump: '不跳转'
      },
      classify: {
        logistics: '物流',
        catering: '餐饮',
        travel: '旅游',
        hotel: '酒店',
        education: '教育',
        internet: '互联网'
      },
      add: {
        title: '发布广告',
        adName: '广告名称',
        adNamePlaceholder: '必填，请填写广告名称',
        classify: '广告分类',
        classifyPlaceholder: '必填，请选择广告分类',
        locationTypeCd: '投放位置',
        locationPlaceholder: '必填，请选择投放位置',
        advertType: '发布类型',
        advertTypePlaceholder: '必填，请选择发布类型',
        pageUrl: '跳转路径',
        pageUrlPlaceholder: '请填写跳转路径',
        seq: '播放顺序',
        seqPlaceholder: '必填，请填写播放顺序',
        startTime: '投放时间',
        startTimePlaceholder: '必填，请填写投放时间',
        endTime: '结束时间',
        endTimePlaceholder: '必填，请填写结束时间',
        viewType: '播放方式',
        viewTypePlaceholder: '必填，请选择播放方式',
        image: '图片(800 * 373)',
        success: '广告发布成功'
      },
      edit: {
        title: '修改广告',
        adName: '广告名称',
        adNamePlaceholder: '必填，请填写广告名称',
        classify: '广告分类',
        classifyPlaceholder: '必填，请选择广告分类',
        locationTypeCd: '投放位置',
        locationPlaceholder: '必填，请选择投放位置',
        advertType: '发布类型',
        advertTypePlaceholder: '必填，请选择发布类型',
        pageUrl: '跳转路径',
        pageUrlPlaceholder: '请填写跳转路径',
        seq: '播放顺序',
        seqPlaceholder: '必填，请填写播放顺序',
        startTime: '投放时间',
        startTimePlaceholder: '必填，请填写投放时间',
        endTime: '结束时间',
        endTimePlaceholder: '必填，请填写结束时间',
        viewType: '播放方式',
        viewTypePlaceholder: '必填，请选择播放方式',
        image: '图片(800 * 373)',
        success: '广告修改成功'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除发布广告',
        success: '广告删除成功'
      },
      machine: {
        title: '广告设备码',
        machineCode: '设备编码',
        machineCodePlaceholder: '必填，请填写设备编码',
        view: '查看广告'
      },
       validate: {
        adNameRequired: 'Advertisement name is required',
        classifyRequired: 'Advertisement category is required',
        locationRequired: 'Placement location is required',
        advertTypeRequired: 'Publish type is required',
        seqRequired: 'Play order is required',
        seqNumber: 'Play order must be a number',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        viewTypeRequired: 'Play method is required',
        imageRequired: 'Please upload image',
        machineCodeRequired: 'Device code is required'
      },
      fetchError: '获取广告列表失败',
      fetchLocationError: '获取位置类型失败'
    }
  }
}